import { z } from "zod";
export const npdProductDtoSchema = z.object({
    id: z.number(),
    name: z.string(),
    specialCharacteristics: z.string(),
    description: z.string().nullable(),
});
